import { render, staticRenderFns } from "./OrderEditAndCreate.vue?vue&type=template&id=00083dfc&scoped=true&"
import script from "./OrderEditAndCreate.vue?vue&type=script&lang=js&"
export * from "./OrderEditAndCreate.vue?vue&type=script&lang=js&"
import style0 from "./OrderEditAndCreate.vue?vue&type=style&index=0&id=00083dfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00083dfc",
  null
  
)

export default component.exports